import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover
} from "react-bootstrap";
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Card} from "components/Card/Card.jsx";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import {hasPermission} from 'helper/hasPermission';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import {adminLabels} from '../../../redux/constant/admin-label-constant';
import OpenModalButton from '../../ThemeComponents/openModelButton';
import {helperFunctions as HF} from '../../../helper/helperFunctions';
import {withRouter} from 'react-router-dom';
import AddEditAddressForm from './../../ThemeComponents/AddEditAddressForm';
import {listActions} from '../../../redux/actions/list-actions';
import {addressActions} from "../../../redux/actions/address-actions";
import SimpleReactValidator from "simple-react-validator";

// add new tag type form component and files //
import ListForm from '../Lists/ListForm';
import {objectsConstants as OC} from 'redux/constant/objects-constant';

// dropdown components //
import CustomerDropdown from "../Customers/CustomerDropdown";
import BrandsDropdown from "../Brands/BrandsDropdown";

var Modal = require('react-bootstrap-modal');

class BrandAddressList extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();

        const user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : undefined;
        let model_id;
        let model;
        if (user.model === 'App\\Customer' || user.model === 'App\\Brand') {
            model_id = user.model_id;
            model = this.props.match.params.model;
        } else {
            model_id = this.props.match.params.id;
            model = this.props.match.params.model;
        }

        this.state = {
            loggedInUserType: user.model,
            addModal: false,
            editModal: false,
            pageSize: 10,
            listData: [],

            initialState: {
                address: {
                    country_id: '',
                    country: '',
                    model_id: model_id,
                    model: model
                }
            },
            user: {
                address: {
                    country_id: '',
                    country: '',
                    model_id: model_id,
                    model: model,
                    type: '',
                    type_id: '',
                }
            },
            submitted: false,
            showDropdown: this.props.match.params.id !== 'all' ? false : true,

            tagTypeList: {},
            addNewModelType: '',
            addNewModelDisplayTitle: '',
            tagTypeParentId: '',
            list_type_id: null,
            tagTypeAddModal: false
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleEditFormSubmit = this.handleEditFormSubmit.bind(this);
    };

    handleDropDownAddNewSubmit = (listData, formType) => {
        let list;
        if (this.state.addNewModelType === 'region') {
            list = {
                title: listData.title,
                list_type_id: this.state.list_type_id,
                list_type: this.state.addNewModelType,
                parent_id: this.state.user.address.country_id,
                parent: this.state.user.address.country,
                component_name: this.state.addNewModelDisplayTitle
            };
        } else {
            list = {
                title: listData.title,
                list_type_id: this.state.list_type_id,
                list_type: this.state.addNewModelType,
                component_name: this.state.addNewModelDisplayTitle
            };
        }

        this.props.storeTagTypeCall(list).then(
            response => {
                if (this.state.addNewModelType === 'region') {
                    this.props.refreshRegionsListCall(this.state.user.address.country_id);
                }
                this.props.getListCall(this.state.addNewModelType, "", "", "", "", this.state.addNewModelType, false);
                this.setState({
                    ...this.state,
                    tagTypeAddModal: false,
                });
            },
            error => {
                return error;
            }
        );
    }

    getState = state => {
        if (state.tagTypeAddModal !== undefined) {
            this.setState(prevState => ({
                ...prevState.tagTypeAddModal,
                ...state
            }));
        } else {
            this.setState(prevState => ({
                user: {
                    address: {
                        ...prevState.user.address,
                        ...state.address
                    }
                }
            }));
        }
    };

    refreshComponent = () => {
        const {initialState} = this.state;
        this.props.getListCall('country', "", "", "", "", "country", false);
        this.props.getListCall('address', "", "", "", "", "address", false).then(res => {
            this.setState({
                address: res.list_type_listing.data
            })
        });
    }

    componentDidMount() {
        const {initialState} = this.state;
        this.refreshComponent(initialState.address.model_id, initialState.address.model);
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.model !== prevProps.match.params.model) {
            window.location.reload();
        }
        if (prevProps.listData !== this.props.listData) {
            this.setState({
                listData: this.props.listData
            })
        }
    }

    getFullState = state => {
        this.setState(prevState => ({
            user: {
                ...prevState.user,
                address: {
                    ...prevState.user.address,
                    ...state
                }
            },
            initialState: {
                ...prevState.initialState,
                address: {
                    ...prevState.initialState.address,
                    ...state
                }
            }
        }), () => {
            if (this.state.initialState.address.model_id !== 'all')
                this.props.getAllAddressesCall(this.state.initialState.address.model_id, this.state.initialState.address.model, this.state.filtered, '', '', this.state.pageSize)
        });
    }

    handleFormSubmit(data) {
        if (this.validator.allValid()) {
            this.validator.hideMessages();
            this.setState({
                submitted: true
            });
            const {user, initialState} = this.state;
            this.props.storeAddressCall(user.address).then(
                response => {
                    this.props.getAllAddressesCall(initialState.address.model_id, initialState.address.model, this.props.current_page, '', this.state.pageSize);
                    this.setState({
                        ...this.state,
                        addModal: false,
                        user: this.state.initialState
                    })
                }
            )
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    handleEditFormSubmit(data) {
        if (this.validator.allValid()) {
            this.setState({
                submitted: true
            });
            const {user, initialState} = this.state;
            this.props.editAddressCall(user.address, user.address.id).then(
                response => {
                    this.props.getAllAddressesCall(initialState.address.model_id, initialState.address.model, this.props.current_page, '', this.state.pageSize);
                    this.setState({
                        ...this.state,
                        editModal: false,
                        user: this.state.initialState
                    })
                }
            );
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    addressTypeChangeHandler = (obj) => {

        this.setState(prevState => ({
            user: {
                address: {
                    ...prevState.user.address,
                    type: obj.type,
                    type_id: obj.type_id,
                }
            }
        }));
    }

    callEditAddress(id) {
        this.props.getAddressItemCall(id).then(response => {
            this.setState(prevState => ({
                ...prevState,
                user: {
                    ...prevState.user,
                    address: this.props.addressItem
                }
            }));

            this.setState({
                editModal: true
            });
        });
    }

    deleteListItem(list_id) {
        const {initialState} = this.state;
        this.props.deleteListCall(list_id).then(response => {
            this.props.getAllAddressesCall(initialState.address.model_id, initialState.address.model, this.props.current_page, '', this.state.pageSize);
        });
    }

    deleteConfirmListItem(list_id) {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Confirmalertfordelete typeName="Address" onClosePro={onClose}
                                           deleteType={() => this.deleteListItem(list_id)}/>
                )
            }
        })
    }

    listingPaginationData = (page, sort, pageSize) => {
        const {initialState} = this.state;
        this.setState({pageSize: pageSize}, function () {
            this.props.getAllAddressesCall(initialState.address.model_id, initialState.address.model, page, sort, pageSize);
        });
    }

    checkPermissions = () => {
        if (HF.checkRoleAndDisplayMenu([
            "super admin",
            "zabin Staff"
        ])) {
            return hasPermission('customer-can-manage-their-addresses') || hasPermission('manage-brand-addressses');
        } else if (HF.checkRoleAndDisplayMenu([
            "customer manager"
        ])) {
            return hasPermission('customer-can-manage-their-addresses');
        } else if (HF.checkRoleAndDisplayMenu([
            "brand manager"
        ])) {
            return hasPermission('manage-brand-addressses');
        }
    }

    render() {
        const {filtered, initialState} = this.state;
        const {pages, loading} = this.props;
        const columns = [
            {
                Header: <div className='text-capitalize'>Address List</div>,
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: <div className='text-capitalize'>Title</div>,
                        accessor: "title",
                        className: "action-center text-capitalize"
                    },
                    {
                        Header: <div className='text-capitalize'>Address</div>,
                        accessor: "line1",
                        className: "action-center text-capitalize"
                    },
                    {
                        Header: <div className='text-capitalize'>Country</div>,
                        accessor: "country",
                        className: "action-center text-capitalize"
                    },
                    {
                        Header: <div className='text-capitalize'>Region</div>,
                        accessor: "region",
                        className: "action-center text-capitalize"
                    },
                    {
                        Header: <div className='text-capitalize'>City</div>,
                        accessor: "city",
                        className: "action-center text-capitalize"
                    },
                    {
                        Header: <div className='text-capitalize'>Type</div>,
                        accessor: "type",
                        className: "action-center text-capitalize"
                    },
                    {
                        Header: "Actions",
                        accessor: "id",
                        Cell: ({original, value}) => (
                            <div>
                                <OverlayTrigger placement="bottom" overlay={<Popover
                                    id="tooltip">{hasPermission(['customer-can-manage-their-addresses', 'manage-brand-addressses']) ? `Edit Address` : adminLabels.DONT_ALLOW}</Popover>}>
									<span>
										{
                                            hasPermission(['customer-can-manage-their-addresses', 'manage-brand-addressses']) &&
                                            <button type='button' className="editIcon orderDetailsAction "
                                                    onClick={() => this.callEditAddress(value)}>&nbsp;</button>

                                        }
                                        {
                                            !hasPermission(['customer-can-manage-their-addresses', 'manage-brand-addressses']) &&
                                            <button type='button'
                                                    className="editIcon orderDetailsAction button_disabled">&nbsp;</button>
                                        }
									</span>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Popover
                                    id="tooltip">{hasPermission(['delete-customer-address', 'manage-brand-addressses']) ? `Delete Address` : adminLabels.DONT_ALLOW}</Popover>}>
									<span>
                                        {
                                            hasPermission(['delete-customer-address', 'manage-brand-addressses']) && (original.type !== 'primary') ?
                                                <button type='button' className="deleteIcon orderDetailsAction"
                                                        onClick={() => this.deleteConfirmListItem(value)}>&nbsp;</button>
                                                :
                                                <button type='button'
                                                        className="deleteIcon orderDetailsAction button_disabled">&nbsp;</button>
                                        }

                                        {/*{*/}
                                        {/*	hasPermission(['delete-customer-address','manage-brand-addressses'])  && (original.type !== 'primary' || window.location.href.includes('brand')) &&*/}
                                        {/*	<button type='button' className="deleteIcon orderDetailsAction" onClick={() => this.deleteConfirmListItem(value)}>&nbsp;</button>*/}
                                        {/*}*/}
                                        {/*{*/}
                                        {/*	!hasPermission(['delete-customer-address','manage-brand-addressses']) || (original.type !== 'primary' && !window.location.href.includes('brand')) &&*/}
                                        {/*	<button type='button' className="deleteIcon orderDetailsAction button_disabled" >&nbsp;</button>*/}
                                        {/*}*/}
									</span>
                                </OverlayTrigger>
                            </div>
                        ),
                        className: "action-center",
                        sortable: false
                    }
                ]
            }
        ];

        return (
            <React.Fragment>

                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Card
                                    ctTableResponsive
                                    content={
                                        <div>
                                            {this.state.showDropdown &&
                                            <div className="col-md-5" style={{paddingRight: '10px', float: 'right'}}>
                                                {this.props.match.params.model === 'customer' &&
                                                <CustomerDropdown onReturnFullState={this.getFullState}
                                                                  stateProp={this.state}
                                                                  selectedCustomer={initialState.address.model_id}
                                                                  modelProp={this.state.loggedInUserType}/>
                                                }
                                                {this.props.match.params.model === 'brand' &&
                                                <BrandsDropdown onReturnFullState={this.getFullState}
                                                                stateProp={this.state}
                                                                selectedCustomer={initialState.address.model_id}
                                                                modelProp={this.state.loggedInUserType}/>
                                                }
                                            </div>
                                            }

                                            <Grid fluid>
                                                <Row>
                                                    <Col md={12}>
                                                        <h3 style={{
                                                            textAlign: 'center',
                                                            fontWeight: "500",
                                                            textTransform: "capitalize"
                                                        }}>Manage Addresses</h3>
                                                    </Col>

                                                    <Col md={12}>
                                                        <div className="flexElem mt-xlg flexResponsive" style={{
                                                            "alignItems": "flex-start",
                                                            "justifyContent": "space-between"
                                                        }}>
                                                            <div className="block">
                                                                {(initialState.address.model_id !== 'all' && initialState.address.model_id !== undefined) &&
                                                                <OpenModalButton
                                                                    openModal={hasPermission(['customer-can-manage-their-addresses', 'manage-brand-addressses']) ? HF.openModal.bind(this, "addModal") : null}
                                                                    classButton={['customBtn btnBlue', !hasPermission(['customer-can-manage-their-addresses', 'manage-brand-addressses']) ? 'button_disabled' : '']}
                                                                    buttonName={'Add Address'}
                                                                    tooltipText={`Add Address`}
                                                                    classIcon={['']}
                                                                />
                                                                }
                                                                {(initialState.address.model_id === 'all' || initialState.address.model_id === undefined) &&
                                                                <OpenModalButton
                                                                    classButton={['customBtn btnBlue button_disabled']}
                                                                    buttonName={'Add Address'}
                                                                    tooltipText={'Please select ' + initialState.address.model + ' to Add new Address'}
                                                                    classIcon={['']}
                                                                />
                                                                }
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col md={12} className="mt-xlg">
                                                        <ReactTable
                                                            noDataText='No data found'
                                                            data={this.props.addressData}
                                                            pages={pages}
                                                            loading={loading}
                                                            columns={columns}
                                                            filtered={filtered}
                                                            defaultPageSize={10}
                                                            className="-striped listing responsive"
                                                            pageData={this.listingPaginationData}
                                                            manual
                                                            onFetchData={(state, instance) => {
                                                                var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                                state.pageData(state.page + 1, sort, state.pageSize);
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Grid>

                                            {/*Add Country Modal Start*/}
                                            {this.props.addressData !== null &&
                                            <Modal show={this.state.addModal}
                                                   onHide={HF.closeModal.bind(this, "addModal")}
                                                   aria-labelledby="ModalHeader" backdrop={false}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader'
                                                                 className="headerTitle text-capitalize">Add New
                                                        Address</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <AddEditAddressForm
                                                                closeModel={HF.closeModal.bind(this, "addModal")}
                                                                formTypePro="add"
                                                                countries={this.props.country}
                                                                addressTypes={this.props.address}
                                                                addressObject={this.state.user}
                                                                addressTypeChangeHandlerProp={this.addressTypeChangeHandler}
                                                                addressPro={this.state.initialState.address}
                                                                validatorProp={this.validator}
                                                                returnState={this.getState}
                                                                handleFormSubmitProp={this.handleFormSubmit}
                                                                parentData={this.props.listItempParent}
                                                                parent_id={this.state.parent_id}
                                                                resetAfterUnmount={() => {
                                                                    this.setState({
                                                                        user:
                                                                            {
                                                                                address: this.state.initialState.address
                                                                            }
                                                                    })
                                                                }}
                                                                //ref={this.adrsFormRef}
                                                            />
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                            }
                                            {/*Add Country Modal End*/}

                                            {/*Edit Modal Start*/}
                                            {this.props.addressData !== null &&
                                            <Modal show={this.state.editModal}
                                                   onHide={HF.closeModal.bind(this, "editModal")}
                                                   aria-labelledby="ModalHeader" backdrop={false}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader'
                                                                 className="headerTitle text-capitalize">Edit
                                                        Address</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <AddEditAddressForm
                                                                closeModel={HF.closeModal.bind(this, "editModal")}
                                                                formTypePro="edit"
                                                                countries={this.props.country}
                                                                addressTypes={this.props.address}
                                                                addressObject={this.state.user}
                                                                addressTypeChangeHandlerProp={this.addressTypeChangeHandler}
                                                                addressPro={this.props.addressItem}
                                                                validatorProp={this.validator}
                                                                returnState={this.getState}
                                                                handleFormSubmitProp={this.handleEditFormSubmit}
                                                                parentData={this.props.listItempParent}
                                                                parent_id={this.state.parent_id}
                                                                showTagTypeAddModal={this.state.tagTypeAddModal}
                                                                resetAfterUnmount={() => {
                                                                    this.setState({
                                                                        user:
                                                                            {
                                                                                address: this.state.initialState.address
                                                                            }
                                                                    })
                                                                }}
                                                            //ref={this.adrsFormRef}
                                                        />
                                                    </div>
                                                </div>
                                            </Modal.Body>
                                                </Modal>
                                            }
                                            {/*Edit Modal End*/}

                                        </div>
                                    }/>
                            </Col>
                        </Row>
                    </Grid>
                </div>
            </React.Fragment>
        );
    };
}

const mapDispatchToProps = dispatch => {
    return ({
        getListCall: (
            id, page, filter, sort, pageSize, component_name, pagination
        ) => {
            return dispatch(
                listActions.getList(
                    id, page, filter, sort, pageSize, component_name, pagination
                )
            );
        },
        storeAddressCall: data => {
            return dispatch(addressActions.storeAddress(data));
        },
        getAllAddressesCall: (
            id, model, page, sort, pageSize, component_name, pagination
        ) => {
            let resource_id = '';
            if (id === 'all') {
                resource_id = '';
            } else if (id !== undefined) {
                resource_id = id;
            }
            dispatch(
                addressActions.getAddressesPagination(
                    resource_id, model, page, sort, pageSize, component_name, pagination
                )
            );
        },
        getAddressItemCall: (id) => {
            return dispatch(addressActions.getAddressItem(id))
        },
        editAddressCall: (data, id) => {
            return dispatch(addressActions.editAddress(data, id))
        },
        deleteListCall: (id) => {
            return dispatch(addressActions.deleteAddress(id))
        },
        storeTagTypeCall: (listData) => {
            return dispatch(listActions.storeList(listData))
        },
        refreshRegionsListCall: (id) => {
            return dispatch(listActions.getListItem(id))
        }
    });
};

function mapStateToProps(state, ownProps) {
    const {country, address} = state.listReducer;
    const {addressListingData, addressItem} = state.addressReducer;
    return {
        country,
        address,
        addressData: addressListingData,
        addressItem
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandAddressList));



// WEBPACK FOOTER //
// ./src/components/Admin/Addresses/AddressList.jsx